const user = {
  state: {
    user: window.sessionStorage.getItem('user') ? JSON.parse(window.sessionStorage.getItem('user')) : null,
    fullScreen: false
  },
  getters: {
    user(state) {
      return state.user
    },
    fullScreen(state) {
      return state.fullScreen
    },
  },
  mutations: {
    setUser(state, data) {
      state.user = data
    },
    setFullScreen(state, data) {
      state.fullScreen = data
    }
  },
  actions: {
    saveUser({commit}, data) {
      commit('setUser', data)
      if (data !== null && data.checked) {
        window.sessionStorage.setItem('user', JSON.stringify(data))
      } else {
        window.sessionStorage.removeItem('user')
      }
    },
    saveFullScreen({commit}, data) {
      commit('setFullScreen', data)
    }
  }
}
export default user
